<template>
    <div>
        <header>
            <div class="center">
                <div style="display: flex;align-items: center;margin-bottom: 0.12rem;">
                    <p class="p1">收款id:</p>
                    <el-input v-model.trim="init.q.fromCollectionId" placeholder="收款id" size="small"
                              style="width: 1.3rem; margin-right: 0.1rem"></el-input>
                    <el-button size="small" type="primary"
                               @click="init.q.page = 1; getData()">搜索
                    </el-button>
                    <el-button size="small" @click="resetClick">重置</el-button>
                </div>
            </div>
        </header>
        <el-table
            v-loading="loading"
            :data="transferOutDatas"
            border
            style="width: 100%">
            <el-table-column
                align="center"
                fixed="left"
                label="团号"
                prop="fromPlanId">
            </el-table-column>
            <el-table-column
                align="center"
                label="收款时间"
                prop="date">
                <template v-slot:default="scope">
                    {{ scope.row.detail.payDate | dateFormat }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="付款方名称"
                prop="date">
                <template v-slot:default="scope">
                    {{ scope.row.detail.payName }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="收款金额"
                prop="payPrice">
                <template v-slot:default="scope">
                    {{ scope.row.detail.payPrice }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="付款方式"
                prop="date">
                <template v-slot:default="scope">
                    {{ scope.row.detail.payType === 1 ? '微信' : '线下' }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="备注"
                prop="remark">
                <template v-slot:default="scope">
                    {{ scope.row.detail.remark }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="转出方式"
                prop="date">
                <template v-slot:default="scope">
                    {{ scope.row.type === 1 ? '转出到其他团' : '转出到公司余额' }}
                    <span v-if="scope.row.type === 1" style="margin-left: 5px">团号：{{ scope.row.toPlanId }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="转出理由"
                prop="remark">
            </el-table-column>
            <el-table-column
                align="center"
                label="状态">
                <template v-slot:default="scope">
                    <el-tag :type="statusMap[scope.row.status].type">{{statusMap[scope.row.status].name}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                fixed="right"
                label="操作"
                prop="remark">
                <template v-slot:default="scope">
                    <el-button @click="viewDetails(scope.row)" type="primary">查看详情</el-button>
                </template>
            </el-table-column>

        </el-table>
        <footer>
            <Pagination :pageSizes=pageSizes :currentPage="init.page" :parentPageSize="10" :totalNumber="total"
                        @loadTable='loadTable'></Pagination>
        </footer>
        <applyDetail ref="applyDetail"></applyDetail>
    </div>
</template>
<script>
import PayApi from "@/components/Api/pay";
import Pagination from "@/components/Pagination.vue";
import applyDetail from "@/views/mechanism/components/applyDetail.vue";
export default {
    name: "transferOutManagement",
    components: {Pagination,applyDetail},
    data() {
        return {
            pageSizes: [10, 30, 60, 100],
            loading: false,
            total: 0,
            transferOutDatas: [],
            statusMap: {
                '0':{
                    name:'审核中...',
                    type:'info'
                },
                '1':{
                    name:'审核中...',
                    type:'info'
                },
                '2':{
                    name:'审核通过',
                    type:'success'
                },
                '3':{
                    name:'审核失败',
                    type:'danger'
                },
                '10':{
                    name:'转账成功',
                    type:'success'
                },

            },
            init: {
                "page": 1,
                "q": {
                    fromCollectionId:null
                },
                "size": 10
            },
        }
    },
    methods: {
        resetClick() {
            this.init.q = {
                fromCollectionId:null
            }
            this.init.page = 1
            this.getData()
        },
        getData() {
            this.loading = true;
            new PayApi('pay').transferList(this.init).then(res => {
                if (res.status === 200) {
                    console.log(res.data);
                    this.transferOutDatas = res.data.records;
                    this.total = res.data.total;
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$message.error(res.data.statusText);
                }
            })
        },
        //查看详情
        viewDetails(row) {
            this.$refs.applyDetail.beforeOpen(row)
        },
        loadTable(page, size) {
            this.init.size = size
            this.init.page = page
            this.getData()
        },
    },
    mounted() {
       this.$nextTick(() => {
        this.getData();
       })
    }
}
</script>
<style lang="scss" scoped>

.center {
        padding: 0.2rem;
        background-color: #f1f1f1;

        p {
            margin-right: 0.1rem;
        }
    }
</style>